import request from '@/utils/request'
export const getAssetsAggData = () => request({
  url: '/inta/assets/getAssetsAggData',
  method: 'get',
  params:{isHome:false}
})

export const getAssetsAggEntData = () => request({
  url: '/inta/assets/getAssetsAggEntData',
  method: 'get'
})